import styled from '@emotion/styled';

export const FooterWrapper = styled.div`
    padding: 0 10px;
    span {
        opacity: 0.5;
        font-size: 13px;
    }
    img {
        width: 90px;
        height: 37px;
        opacity: 0.5;
        @media (max-width: ${(p) => p.theme.breakpoint.tablet}px) {
            margin-bottom: 8px;
        }
    }
`;
export const Column = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    @media (min-width: ${(p) => p.theme.breakpoint.tablet}px) {
        flex-direction: row;
    }
`;
export const Copyright = styled.p`
    margin-bottom: 0 !important;
    color: ${(p) => p.theme.color.grayDark};
`;
export const Version = styled.p`
    margin-bottom: 0 !important;
    color: ${(p) => p.theme.color.grayDark};
    padding: 10px 10px;
    @media (min-width: ${(p) => p.theme.breakpoint.tablet}px) {
        padding-top: 15px;
    }
`;

export const Divider = styled.div`
    border-top: 1px solid;
    opacity: 0.25;
    margin-top: 16px;
    @media (max-width: ${(p) => p.theme.breakpoint.tablet}px) {
        margin-top: 8px;
    }
`;

export const FooterTextContainer = styled.div`
    height: 60px;
    @media (max-width: ${(p) => p.theme.breakpoint.tablet}px) {
        height: 90px;
    }
`;

export const FooterText = styled.div`
    align-items: center;
    padding: 0 8px;
    display: flex;
    justify-content: space-between;
    height: 63px;
    @media (max-width: ${(p) => p.theme.breakpoint.tablet}px) {
        flex-direction: column;
        padding: 10px 0 0 0;
    }
`;
